<template>
  <div class="buttonContent">
    <el-select v-model="dropDownSelect" placeholder="请选择">
      <el-option
        v-for="(el, i) in codeData"
        :key="i + 'only'"
        :label="el.codeName"
        :value="el.codeName"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { codeType } from '@/api/common.js'
export default {
  props: {
    typeCode: {
      // 查询的字典值
      type: String,
      default: ''
    },
    selectValue: {
      type: String
    }
  },
  data() {
    return {
      codeData: [],
      dropDownSelect: ''
    }
  },
  watch: {
    selectValue: function (newVal) {
      this.dropDownSelect = newVal
    },

    dropDownSelect: function (newVal) {
      this.$emit('update:selectValue', newVal)
    }
  },
  created() {
    this.getCode()
  },
  methods: {
    //根据code查询标签
    async getCode() {
      const res = await codeType({ code: this.typeCode })
      if (res.data.resultCode == 200) {
        this.codeData = res.data.data
      }
    }
  }
}
</script>

<style lang="less" scoped></style>
